// Weergavenamen van de categorieën van rechten (de databank bewaart de korte codes).
export const CATEGORY_LABELS = {
  voorraden: "Voorraad",
  beheer: "Beheer",
  statistieken: "Statistieken",
  brands: "Merken",
  suppliers: "Leveranciers",
  inkomsten: "Inkomsten",
  results: "Resultaten",
  patients: "Patiënten",
  timesheets: "Prestaties",
  veiligheid: "Veiligheid",
};

export function categoryLabel(category) {
  return CATEGORY_LABELS[category] || category.charAt(0).toUpperCase() + category.slice(1);
}
